import { render, staticRenderFns } from "./ProductGallery.vue?vue&type=template&id=78cd38c2&scoped=true"
import script from "./ProductGallery.vue?vue&type=script&lang=js"
export * from "./ProductGallery.vue?vue&type=script&lang=js"
import style0 from "./ProductGallery.vue?vue&type=style&index=0&id=78cd38c2&prod&lang=scss&scoped=true"
import style1 from "./ProductGallery.vue?vue&type=style&index=1&id=78cd38c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cd38c2",
  null
  
)

export default component.exports